const STRUCTURE_CONTENT_CONSTRAINTS_PATH = [
  "data",
  "contentConstraints"
];
const CONTENT_CONSTRAINTS_TIME_PERIOD = "TIME_PERIOD";
export {
  CONTENT_CONSTRAINTS_TIME_PERIOD,
  STRUCTURE_CONTENT_CONSTRAINTS_PATH
};
